export default "__VITE_ASSET__u3pDIkkF__"